import React, { useEffect, useState } from "react";
import {
  LayoutData,
  LayoutHeading,
  LayoutRow,
} from "../../../components/TableComponents/RowBordered/RowBordered";
import ReactTooltip from "react-tooltip";
import { Collapse, Modal, ModalBody, ModalHeader } from "reactstrap";
import moment from "moment";
import Toggle from "react-toggle";
import OoPopover from "../../../components/UI/Popover/OoPopover";
import { sortBy } from "lodash";
import { generateLegendTitle } from "../../../utils/chartUtils";
import { BiTrendingUp } from "react-icons/bi";
import {
  checkNoDataLayoutValidity,
  deterMineKpiTypeForAveragesTable,
  getAvgTenureFormatted,
  getEmptyGraphLayoutObject,
  NA_KPIS,
  PERCENT_KPIS,
} from "../../../utils/constants";

export default function ChartAverageTable({
  kpiForPlotly = [],
  yAxisFormat,
  chartSelector,
  isPopup,
  chart,
}) {
  const [collapseOpen, setCollapseOpen] = useState(false);
  const [avarageType, setAvarageType] = useState("");
  const [showAvg, setShowAvg] = useState(true);
  const [hoveredId, setHoveredId] = useState(null);

  const toggle = () => {
    setCollapseOpen(!collapseOpen);
  };

  useEffect(() => {
    const hideUi = checkNoDataLayoutValidity(kpiForPlotly);

    if (hideUi) {
      setShowAvg(false);
    } else {
      setShowAvg(true);
    }
  }, [kpiForPlotly]);

  useEffect(() => {
    if (yAxisFormat === "Absolute") {
      setAvarageType("Absolute");
    } else {
      setAvarageType("Percent");
    }
  }, [yAxisFormat]);

  const getAverage = (item, time, kpiCodeType) => {
    const coreKpiObject = item;

    // console.log(avarageType, '---- kpiCodeType ----- ', kpiCodeType)

    if (coreKpiObject) {
      const scores =
        coreKpiObject.score && coreKpiObject.score.length > 0
          ? sortBy(coreKpiObject.score, (kpi, i) => kpi.date)
          : [];

      let filteredTimeScores = [];
      let filteredAvgTenure = []

      const isNAKpi = NA_KPIS.includes(coreKpiObject.kpiId.code);

      const isPerKpi = PERCENT_KPIS.includes(coreKpiObject.kpiId.code);

      // console.log(avarageType,'----KPI Code ----', coreKpiObject.kpiId.code, '--- diversity --- ', coreKpiObject.diversityType,"-----isNA-----",isNAKpi)
      if (coreKpiObject.score.length === 0) {
        return { score: "Not Available", tenure: "Not Available" };
      } else {
        if (avarageType === "Percent") {
          if (time === "ALL") {
            filteredTimeScores = [...scores];
            filteredAvgTenure= [...scores.filter(
              (x) => x.avgTenure
            )];
          } else if (time === "1Y") {
            const oneYearBeforeDate = moment(scores[scores.length - 1].date)
              .subtract(11, "months")
              .startOf("month")
              .format("YYYY-MM-DD");

            filteredTimeScores = scores.filter(
              (x) => moment(x.date).format("YYYY-MM-DD") >= oneYearBeforeDate
            );
            filteredAvgTenure = scores.filter(
              (x) => moment(x.date).format("YYYY-MM-DD") >= oneYearBeforeDate && x.avgTenure
            );
          } else if (time === "6M") {
            const sixMonthBeforeDate = moment(scores[scores.length - 1].date)
              .subtract(5, "months")
              .startOf("month")
              .format("YYYY-MM-DD");
            filteredTimeScores = scores.filter(
              (x) => moment(x.date).format("YYYY-MM-DD") >= sixMonthBeforeDate
            );
            filteredAvgTenure = scores.filter(
              (x) => moment(x.date).format("YYYY-MM-DD") >= sixMonthBeforeDate && x.avgTenure
            );
          } else if (time === "3M") {
            const threeMonthBeforeDate = moment(scores[scores.length - 1].date)
              .subtract(2, "months")
              .startOf("month")
              .format("YYYY-MM-DD");
            filteredTimeScores = scores.filter(
              (x) => moment(x.date).format("YYYY-MM-DD") >= threeMonthBeforeDate
            );
            filteredAvgTenure = scores.filter(
              (x) => moment(x.date).format("YYYY-MM-DD") >= threeMonthBeforeDate && x.avgTenure
            );
            // console.log('filteredTimeScores---- ', filteredTimeScores)
          }
          if (chart.kpiType === "SURVEY_BASED") {
            let totalValues = 0;
            let totalTenures = null;
            for (const score of filteredTimeScores) {
              totalValues += score.value;

              if (score.avgTenure >= 0) {
                totalTenures += score.avgTenure ? score.avgTenure : 0;
              }
            }
            const avg = totalValues / filteredTimeScores.length;

            let avgTenure = 0;
            // console.log('totalTenures --- ', totalTenures)
            if (totalTenures != null && filteredTimeScores.length) {
              avgTenure = parseFloat(
                totalTenures / filteredTimeScores.length
              ).toFixed(2);
            } else {
              avgTenure = "NA";
            }
            return {
              score: Math.round(avg) + " %",
              tenure: avgTenure,
            };
          } else {
            let totalNumCounts = 0,
              totalValCounts = 0;
            let totalTenures = 0;
            for (const score of filteredTimeScores) {
              if(score.numeratorType=="-African-American/ Black" && time=='3M'){
                // console.log(filteredTimeScores, '---- avg score ---- ', score)
              }
              // totalNumCounts += isPerKpi? score.value :score.numeratorCount;
              if (isPerKpi) {
                totalNumCounts += score.value;
              } else {
                totalNumCounts += score.numeratorCount;
              }
              totalValCounts += score.totalEmployees;
              if (score.avgTenure && score.avgTenure > 0) {
                if(score.numeratorType=="-African-American/ Black"&& time=='3M'){
                  // console.log(filteredTimeScores, '---- avg score ---- ', score)
                }
                
                totalTenures += score.avgTenure ? score.avgTenure : 0;
                
              }
            }


            let avgTenure = 0;
            if (totalTenures>0 && filteredAvgTenure.length>0) {
              // avgTenure = parseFloat(
              //   totalTenures / filteredTimeScores.length
              // ).toFixed(2);
              // console.log('totalTenures --- ', totalTenures)
              avgTenure =  totalTenures / filteredAvgTenure.length
            } else {
              avgTenure = "NA";
            }


            let avg;
            if (isPerKpi) {
              avg = totalNumCounts / filteredTimeScores.length;
            } else {
              avg = (totalNumCounts / totalValCounts) * 100;
            }


            // let scoreFormatted =  isNaN(avg)?  "Not Available":Math.round(avg) + " %"

            return {
              score: Math.round(avg) + " %",
              tenure: avgTenure,
            };
          }
        } else if (avarageType === "Absolute") {
          if (chart.kpiType === "SURVEY_BASED") {
            if (time === "ALL") {
              filteredTimeScores = [scores[scores.length - 1]];
            } else if (time === "1Y") {
              const prev1YearFirstDay = moment(scores[scores.length - 1].date)
                .subtract(11, "months")
                .startOf("month");

              const prev1YearLastDay = moment(scores[scores.length - 1].date)
                .subtract(11, "months")
                .endOf("month");

              filteredTimeScores = scores.filter((x) =>
                moment(x.date).isBetween(prev1YearFirstDay, prev1YearLastDay)
              );
            } else if (time === "6M") {
              const prev6MonthFirstDay = moment(scores[scores.length - 1].date)
                .subtract(5, "months")
                .startOf("month");

              const prev6MonthLastDay = moment(scores[scores.length - 1].date)
                .subtract(5, "months")
                .endOf("month");

              filteredTimeScores = scores.filter((x) =>
                moment(x.date).isBetween(prev6MonthFirstDay, prev6MonthLastDay)
              );
            } else if (time === "3M") {
              const prev3MonthFirstDay = moment(scores[scores.length - 1].date)
                .subtract(2, "months")
                .startOf("month");

              const prev3MonthLastDay = moment(scores[scores.length - 1].date)
                .subtract(2, "months")
                .endOf("month");

              filteredTimeScores = scores.filter((x) =>
                moment(x.date).isBetween(prev3MonthFirstDay, prev3MonthLastDay)
              );
            }

            let finalObject = null;

            if (filteredTimeScores.length) {
              finalObject = filteredTimeScores[filteredTimeScores.length - 1];
            }

            if (finalObject) {
              const avg = finalObject.value;
              return {
                score: `${Math.round(avg)} %`,
                tenure:
                  finalObject.avgTenure > 0
                    ? parseFloat(finalObject.avgTenure).toFixed(2) ||
                      "Not Available"
                    : "Not Available",
              };
            } else {
              return { score: "Not Available", tenure: "Not Available" };
            }
          }
          if (kpiCodeType == "CUMULATIVE") {
            if (time === "ALL") {
              filteredTimeScores = [...scores];
              filteredAvgTenure= [...scores.filter(
                (x) => x.avgTenure
              )];
            } else if (time === "1Y") {
              const oneYearBeforeDate = moment(scores[scores.length - 1].date)
                .subtract(11, "months")
                .startOf("month")
                .format("YYYY-MM-DD");

              filteredTimeScores = scores.filter(
                (x) => moment(x.date).format("YYYY-MM-DD") >= oneYearBeforeDate
              );
              filteredAvgTenure = scores.filter(
                (x) => moment(x.date).format("YYYY-MM-DD") >= oneYearBeforeDate && x.avgTenure
              );
            } else if (time === "6M") {
              const sixMonthBeforeDate = moment(scores[scores.length - 1].date)
                .subtract(5, "months")
                .startOf("month")
                .format("YYYY-MM-DD");
              filteredTimeScores = scores.filter(
                (x) => moment(x.date).format("YYYY-MM-DD") >= sixMonthBeforeDate
              );
              filteredAvgTenure = scores.filter(
                (x) => moment(x.date).format("YYYY-MM-DD") >= sixMonthBeforeDate && x.avgTenure
              );
            } else if (time === "3M") {
              const threeMonthBeforeDate = moment(
                scores[scores.length - 1].date
              )
                .subtract(2, "months")
                .startOf("month")
                .format("YYYY-MM-DD");
              filteredTimeScores = scores.filter(
                (x) =>
                  moment(x.date).format("YYYY-MM-DD") >= threeMonthBeforeDate
              );
              filteredAvgTenure = scores.filter(
                (x) => moment(x.date).format("YYYY-MM-DD") >= threeMonthBeforeDate && x.avgTenure
              );
            }

            let totalNumCounts = 0;
            let totalValCounts = 0;
            let totalTenures = 0;

            for (const score of filteredTimeScores) {
              // totalNumCounts += score.numeratorCount;
              // console.log(isPerKpi,'---- score ----- ', score)

              // totalNumCounts += isPerKpi? score.value :score.numeratorCount;
              totalNumCounts += score.numeratorCount;
              if (score.avgTenure >= 0) {
                totalTenures += score.avgTenure ? score.avgTenure : 0;
              }
              // if(!isPerKpi){
              //   totalNumCounts +=  score.numeratorCount;
              //   totalValCounts += score.totalEmployees
              // } else {
              //   totalNumCounts += score.value
              // }
              // console.log('totalNumCounts-----',totalNumCounts,'----totalValCounts --- ',totalValCounts)
            }


            let avgTenure = 0;
            if (totalTenures>0 && filteredAvgTenure.length>0) {
              // avgTenure = parseFloat(
              //   totalTenures / filteredTimeScores.length
              // ).toFixed(2);
              // console.log('totalTenures --- ', totalTenures)
              avgTenure =  totalTenures / filteredAvgTenure.length
            } else {
              avgTenure = "NA";
            }

            // let avgTenure = 0;
            // if (totalTenures != null && filteredTimeScores.length) {
            //   avgTenure = parseFloat(
            //     totalTenures / filteredTimeScores.length
            //   ).toFixed(2);
            // } else {
            //   avgTenure = "NA";
            // }
            let percent_avg = 0;
            let avg = Math.round(totalNumCounts);
            // if(!isPerKpi){
            //   percent_avg = Math.round(totalNumCounts/totalValCounts)*100
            //   avg = percent_avg + '%'
            // }
            // console.log('avg ----> ', avg)
            return { score: avg, tenure: avgTenure };
          } else if (kpiCodeType === "HISTORICAL") {
            if (time === "ALL") {
              filteredTimeScores = [scores[scores.length - 1]];
            } else if (time === "1Y") {
              const prev1YearFirstDay = moment(scores[scores.length - 1].date)
                .subtract(11, "months")
                .startOf("month");

              const prev1YearLastDay = moment(scores[scores.length - 1].date)
                .subtract(11, "months")
                .endOf("month");

              filteredTimeScores = scores.filter((x) =>
                moment(x.date).isBetween(prev1YearFirstDay, prev1YearLastDay)
              );
            } else if (time === "6M") {
              const prev6MonthFirstDay = moment(scores[scores.length - 1].date)
                .subtract(5, "months")
                .startOf("month");

              const prev6MonthLastDay = moment(scores[scores.length - 1].date)
                .subtract(5, "months")
                .endOf("month");

              filteredTimeScores = scores.filter((x) =>
                moment(x.date).isBetween(prev6MonthFirstDay, prev6MonthLastDay)
              );
            } else if (time === "3M") {
              const prev3MonthFirstDay = moment(scores[scores.length - 1].date)
                .subtract(2, "months")
                .startOf("month");

              const prev3MonthLastDay = moment(scores[scores.length - 1].date)
                .subtract(2, "months")
                .endOf("month");

              filteredTimeScores = scores.filter((x) =>
                moment(x.date).isBetween(prev3MonthFirstDay, prev3MonthLastDay)
              );
            }

            if (chart.kpiType === "SURVEY_BASED") {
              return { score: "Not Available", tenure: "Not Available" };
            } else {
              let finalObject = null;

              if (filteredTimeScores.length) {
                finalObject = filteredTimeScores[filteredTimeScores.length - 1];
              }

              if (finalObject) {
                const avg = isPerKpi
                  ? finalObject.value
                  : finalObject.numeratorCount;
                return {
                  score: `${Math.round(avg)} ${isPerKpi ? "%" : ""}`,
                  tenure:
                    finalObject.avgTenure > 0
                      ? parseFloat(finalObject.avgTenure).toFixed(2) ||
                        "Not Available"
                      : "Not Available",
                };
              } else {
                return { score: "Not Available", tenure: "Not Available" };
              }
            }
          }
        }
      }
    } else {
      return { score: "Not Available", tenure: "Not Available" };
    }
  };






  const changeAverageType = () => {
    if (avarageType === "Absolute") {
      setAvarageType("Percent");
    } else {
      setAvarageType("Absolute");
    }
  };

  if (showAvg && chart) {
    const kpiCodeType = deterMineKpiTypeForAveragesTable(chart.kpiData);
    const renderPopover = () => {
      return (
        <OoPopover
          target={chartSelector + "_plotlychartaverages"}
          placement="top"
          headerText="View trends"
          bodyText={`Historical reflects the value at the beginning of a period.
              Cumulative reflects the totals added over the period (e.g. hiring, retention and promotion).`}
        />
      );
    };

    const renderUi = (kpiCodeType) => {
      const kpiForPlotlyFiltered =
        (chart && chart.kpiData.filter((kpi) => kpi.score.length)) || [];

      const naCheck = (text) => {
        if (text) {
          const txt = text.toString();
          return txt.indexOf("N") > -1 && txt.indexOf("A") > -1;
        } else {
          return true;
        }
      };


    

      return (
        <div className="chart-average-table px-3 mt-3 cursor-pointer">
          <LayoutRow>
            <LayoutHeading>KPI</LayoutHeading>
            <LayoutHeading>
              3 Months{" "}
              {kpiCodeType === "HISTORICAL" &&
              // chart.kpiType !== "SURVEY_BASED" &&
              avarageType === "Absolute"
                ? "Ago"
                : ""}
            </LayoutHeading>
            <LayoutHeading>
              6 Months{" "}
              {kpiCodeType === "HISTORICAL" &&
              // chart.kpiType !== "SURVEY_BASED" &&
              avarageType === "Absolute"
                ? "Ago"
                : ""}
            </LayoutHeading>
            <LayoutHeading>
              1 Year{" "}
              {kpiCodeType === "HISTORICAL" &&
              // chart.kpiType !== "SURVEY_BASED" &&
              avarageType === "Absolute"
                ? "Ago"
                : ""}
            </LayoutHeading>
            <LayoutHeading>
              {kpiCodeType === "HISTORICAL" &&
              // chart.kpiType !== "SURVEY_BASED" &&
              avarageType === "Absolute"
                ? "Latest"
                : "All"}
            </LayoutHeading>
          </LayoutRow>
          {kpiForPlotlyFiltered &&
            kpiForPlotlyFiltered.length > 0 &&
            kpiForPlotlyFiltered.map((kpi, index) => {
              let kpi_name = generateLegendTitle(
                kpi,
                kpi.kpiId.description,
                index,
                false,
                "",
                ""
              );
              let isAvgTenureExists = false;

              const existWithAvgTenure = kpi.score.find(
                (x) => x.avgTenure && x.avgTenure != null
              );

              if (existWithAvgTenure) {
                isAvgTenureExists = true;
              }
              return (
                <LayoutRow key={index}>
                  <LayoutData>
                    <div className="objective-title-layout" data-tip={kpi_name}>
                      {kpi_name} <ReactTooltip />
                    </div>
                    {isAvgTenureExists && <div className="objective-title-layout">Avg Tenure</div>}
                  </LayoutData>
                  <LayoutData>
                    <div
                      onMouseEnter={() => setHoveredId(`${index}_A`)}
                      onMouseLeave={() => setHoveredId(null)}
                    >
                      <div>
                        {getAverage(kpi, "3M", kpiCodeType) &&
                          getAverage(kpi, "3M", kpiCodeType).score}
                      </div>

                      <div>
                        { isAvgTenureExists && getAverage(kpi, "3M", kpiCodeType) &&
                        !naCheck(getAverage(kpi, "3M", kpiCodeType).tenure) ? (
                          
                          <span>
                            {getAvgTenureFormatted(
                              getAverage(kpi, "3M", kpiCodeType).tenure 
                            )}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </LayoutData>
                  <LayoutData>
                    <div
                      onMouseEnter={() => setHoveredId(`${index}_B`)}
                      onMouseLeave={() => setHoveredId(null)}
                    >
                      {getAverage(kpi, "6M", kpiCodeType) &&
                        getAverage(kpi, "6M", kpiCodeType).score}{" "}
                      <div>
                        {isAvgTenureExists && getAverage(kpi, "6M", kpiCodeType) &&
                        !naCheck(getAverage(kpi, "6M", kpiCodeType).tenure) ? (
                          <span>
                            {getAvgTenureFormatted(
                              getAverage(kpi, "6M", kpiCodeType).tenure
                            )}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </LayoutData>
                  <LayoutData>
                    <div
                      onMouseEnter={() => setHoveredId(`${index}_C`)}
                      onMouseLeave={() => setHoveredId(null)}
                    >
                      {getAverage(kpi, "1Y", kpiCodeType) &&
                        getAverage(kpi, "1Y", kpiCodeType).score}{" "}
                      <div>
                        {isAvgTenureExists && getAverage(kpi, "1Y", kpiCodeType) &&
                        !naCheck(getAverage(kpi, "1Y", kpiCodeType).tenure) ? (
                          <span>
                            {getAvgTenureFormatted(
                              getAverage(kpi, "1Y", kpiCodeType).tenure
                            )}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </LayoutData>
                  <LayoutData>
                    <div
                      onMouseEnter={() => setHoveredId(`${index}_D`)}
                      onMouseLeave={() => setHoveredId(null)}
                    >
                      {getAverage(kpi, "ALL", kpiCodeType) &&
                        getAverage(kpi, "ALL", kpiCodeType).score}{" "}
                      <div>
                        {isAvgTenureExists && getAverage(kpi, "ALL", kpiCodeType) &&
                        !naCheck(getAverage(kpi, "ALL", kpiCodeType).tenure) ? (
                          <span>
                            {getAvgTenureFormatted(
                              getAverage(kpi, "ALL", kpiCodeType).tenure
                            )}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </LayoutData>
                </LayoutRow>
              );
            })}
        </div>
      );
    };

    return (
      <div>
        <div className="avg-table-operate-div" style={{ zIndex: 99999 }}>
          <span
            className="accordion-average"
            onClick={() => setCollapseOpen(!collapseOpen)}
          >
            {/* summary, insights,patterns */}
            View Trends <BiTrendingUp size="14px" />
            {/* <i className="flaticon-down-arrow"></i> */}
          </span>

          {chart &&
          // chart.kpiType != "SURVEY_BASED" &&
          collapseOpen &&
          !isPopup ? (
            <div className="avg-toggle-div">
              <span
                className={`mr-1 ml-2 ${
                  avarageType === "Percent"
                    ? "avg_toggle_type"
                    : "kpi_code_type_unhighlight"
                } `}
              >
                {"Average"}
              </span>
              <Toggle
                checked={avarageType === "Absolute"}
                onChange={() => changeAverageType()}
                icons={false}
                // disabled={chart && chart.kpiType === "SURVEY_BASED"}
                color="#023d75"
                className="trends_toggle"
              />

              {/* {chart.kpiType !== "SURVEY_BASED" ? ( */}
              <span
                className={`ml-1 ${
                  avarageType === "Percent"
                    ? "kpi_code_type_unhighlight"
                    : "kpi_code_type_highlight"
                }`}
              >
                {kpiCodeType === "HISTORICAL"
                  ? "Historical"
                  : kpiCodeType === "CUMULATIVE"
                  ? "Cumulative"
                  : ""}
              </span>
              {/* // ) : (
              //   ""
              // )} */}
            </div>
          ) : // chart &&
          //   chart.kpiType == "SURVEY_BASED" &&
          //   collapseOpen &&
          //   !isPopup ? (
          //   <div>
          //     {chart.kpiType !== "SURVEY_BASED" ? (
          //       <span className="ml-1 kpi_code_type_unhighlight">
          //         {kpiCodeType === "HISTORICAL"
          //           ? "Historical"
          //           : kpiCodeType === "CUMULATIVE"
          //           ? "Cumulative"
          //           : ""}
          //       </span>
          //     ) : (
          //       ""
          //     )}
          //     <span class="trend-analysis-survey-kpi-note ml-2">
          //       Trend totals are not available to survey based charts
          //     </span>
          //   </div>
          // )
          null}

          {chartSelector && !isPopup ? renderPopover() : ""}
        </div>

        {isPopup ? (
          <Modal toggle={toggle} isOpen={collapseOpen}>
            <ModalHeader toggle={toggle} className="chart-view-trend-modal">
              {chart.name}
            </ModalHeader>
            <ModalBody>
              <div className="avg-toggle-div">
                <span className="mr-1 ml-2 avg_toggle_type">{"Average"}</span>

                <Toggle
                  checked={avarageType === "Absolute"}
                  onChange={() => changeAverageType()}
                  icons={false}
                  color="#023d75"
                  className="trends_toggle"
                />

                {/* {chart.kpiType !== "SURVEY_BASED" ? ( */}
                <span
                  className={`ml-1 ${
                    avarageType === "Percent"
                      ? "kpi_code_type_unhighlight"
                      : "kpi_code_type_highlight"
                  }`}
                >
                  {kpiCodeType === "HISTORICAL"
                    ? "Historical"
                    : kpiCodeType === "CUMULATIVE"
                    ? "Cumulative"
                    : ""}
                </span>
                {/* ) : (
                  ""
                )} */}

                {chartSelector && !isPopup ? renderPopover() : ""}
              </div>
              {renderUi(kpiCodeType)}
            </ModalBody>
          </Modal>
        ) : (
          <Collapse isOpen={collapseOpen}>{renderUi(kpiCodeType)}</Collapse>
        )}
      </div>
    );
  } else {
    return <div style={{ minHeight: "40px" }}></div>;
  }
}
